import React, { useEffect, useMemo } from 'react';
import { v4 as uuidV4 } from 'uuid';
import PropTypes from 'prop-types';
import { Modal, Button, Form } from 'antd';
import { FormWrapper } from '../../formWrapper/form-wrapper';
import { useDictionaryTranslation } from '../../../hooks/useDictionaryTranslation';
import useMobileFormValues from '../hooks/useMobileFormValues';

export const ModalEditLoopItem = ({ title, show, fields, renderFields, values, handleClose, nodeHierarchy = [] }) => {
  const [form] = Form.useForm();
  const formId = useMemo(uuidV4, []);

  const { translate: t } = useDictionaryTranslation();
  const { mobileFormValues, updateMobileFormValues, updateFieldValue, getValuesToSave } = useMobileFormValues({
    defaultValues: values,
  });

  const onChangeFieldValue = (idInput, value) => {
    updateFieldValue({ idInput, value });
  };

  const closeModal = () => {
    handleClose();
  };

  const saveItem = () => {
    handleClose({ saveValues: true, values: getValuesToSave() });
  };

  useEffect(() => {
    form.setFieldsValue(values);
    updateMobileFormValues(values);
  }, [values]);

  return (
    <Modal
      maskClosable={false}
      title={title}
      centered
      width="60%"
      height="70%"
      onCancel={closeModal}
      destroyOnClose
      visible={show}
      footer={
        <Button form={formId} htmlType="submit" type="primary">
          {t('accept')}
        </Button>
      }
    >
      <FormWrapper>
        <Form form={form} name={formId} layout="vertical" onFinish={saveItem}>
          {renderFields({ formFields: fields, values: mobileFormValues, onChange: onChangeFieldValue, nodeHierarchy })}
        </Form>
      </FormWrapper>
    </Modal>
  );
};

ModalEditLoopItem.propTypes = {
  fields: PropTypes.array,
  handleClose: PropTypes.func,
  renderFields: PropTypes.func,
  values: PropTypes.object,
  title: PropTypes.string,
  show: PropTypes.bool,
  nodeHierarchy: PropTypes.array,
};
